document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".desk-tab-button");
    const tabContents = document.querySelectorAll(".desk-tab-content");

    tabButtons.forEach((btn) => {
        btn.addEventListener("click", function () {
            tabButtons.forEach((b) => b.classList.remove("active"));
            this.classList.add("active");

            const productDetail = this.textContent.trim();
            gaEvent('product_details_provided', [productDetail, "", "", "", "", ""], false);

            tabContents.forEach((content) => content.classList.remove("active"));
            const target = this.getAttribute("data-tab");
            document.getElementById(target).classList.add("active");
        });
    });
});

document.querySelectorAll(".more-detail-question").forEach((item) => {
    item.addEventListener("click", function () {
        const productDetail = this.querySelector(".more-detail-text").textContent.trim();
        gaEvent('product_details_provided', [productDetail, "", "", "", "", ""], false);
    });
})

function toggleProdDetail(element) {
    let faqItem = element.parentElement;

    if (faqItem.classList.contains("active")) {
        faqItem.classList.remove("active");
    } else {
        document.querySelectorAll(".more-detail-item.active").forEach(item => {
            item.classList.remove("active");
        });
        faqItem.classList.add("active");
    }
}
